import { FactoryLocator } from "../components/FactoryLocator";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="grain relative">
      <FactoryLocator />
    </main>
  );
}
